// ToastProvider.js (or wherever you defined it)
import React, { useState, createContext, useContext, useCallback } from 'react';
import Toast from './Toast'; // Adjust path

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children, position = 'top-right', maxToasts = 3 }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info', duration = 3000) => {
    const id = Date.now() + Math.random(); // More unique than Date.now() alone
    setToasts((prevToasts) => {
      const newToasts = [...prevToasts, { id, message, type, duration }];
      // Limit to maxToasts — remove oldest if exceeded
      if (newToasts.length > maxToasts) {
        newToasts.shift(); // remove first (oldest)
      }
      return newToasts;
    });

    // Auto-remove after duration
    const timer = setTimeout(() => {
      setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    }, duration);

    return () => clearTimeout(timer); // Return cleanup for advanced use
  }, [maxToasts]);

  const removeToast = useCallback((id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  }, []);

  const toast = {
    success: (message, duration = 3000) => addToast(message, 'success', duration),
    error: (message, duration = 3000) => addToast(message, 'error', duration),
    warning: (message, duration = 3000) => addToast(message, 'warning', duration),
    info: (message, duration = 3000) => addToast(message, 'info', duration),
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}

      {/* Render Toasts */}
      <div className="fixed z-50 space-y-2 pointer-events-none">
        {toasts.map((toast, index) => (
          <div key={toast.id} className="pointer-events-auto">
            <Toast
              message={toast.message}
              type={toast.type}
              duration={toast.duration}
              onClose={() => removeToast(toast.id)}
              position={position}
              index={index} // For staggered animation
            />
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};


// import React, { useState, createContext, useContext, useCallback } from 'react';
// import Toast from './Toast';

// const ToastContext = createContext();

// export const useToast = () => {
//   const context = useContext(ToastContext);
//   if (!context) {
//     throw new Error('useToast must be used within a ToastProvider');
//   }
//   return context;
// };

// export const ToastProvider = ({ children }) => {
//   const [toasts, setToasts] = useState([]);

//   const addToast = useCallback((message, type = 'info', duration = 3000) => {
//     const id = Date.now();
//     setToasts(prevToasts => [...prevToasts, { id, message, type, duration }]);
    
//     // Auto-remove after duration
//     setTimeout(() => {
//       setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
//     }, duration);
//   }, []);

//   const removeToast = useCallback((id) => {
//     setToasts(prevToasts => prevToasts.filter(toast => toast.id !== id));
//   }, []);

//   const toast = {
//     success: (message, duration = 3000) => addToast(message, 'success', duration),
//     error: (message, duration = 3000) => addToast(message, 'error', duration),
//     warning: (message, duration = 3000) => addToast(message, 'warning', duration),
//     info: (message, duration = 3000) => addToast(message, 'info', duration)
//   };

//   return (
//     <ToastContext.Provider value={toast}>
//       {children}
//       <div className="fixed top-4 right-4 z-50 space-y-2">
//         {toasts.map((toast) => (
//           <Toast
//             key={toast.id}
//             message={toast.message}
//             type={toast.type}
//             duration={toast.duration}
//             onClose={() => removeToast(toast.id)}
//           />
//         ))}
//       </div>
//     </ToastContext.Provider>
//   );
// };